<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PP1"></a><a id="GBS.PP1.w.0.0.0"></a></div><div style="display:none;"><a id="GBS.PT2"></a><a id="GBS.PT2.w.0.0.0"></a><a id="GBS.PT2.w.1.0.0"></a></div>
<div style="display:none;"><a id="GBS.PT2.w.1.0.0.1"></a></div><div style="display:none;"><a id="GBS.PT3"></a><a id="GBS.PT3.w.0.0.0"></a></div><div class="flow" style="">
<a class="page full_page_image" id="ORIG-GBS.PP1"></a>
<a id="GBS.PT4"></a><a id="GBS.PT4.w.0.0.0"></a><a id="GBS.PT4.w.1.0.0"></a><a id="GBS.PT4.w.1.1.0"></a><a id="GBS.PT4.w.2.0.0"></a><a id="GBS.PT4.w.2.0.0.1"></a></div>
<div style="display:none;"><a id="GBS.PT4.w.2.0.0.2"></a></div><div style="display:none;"><a id="GBS.PT5"></a><a id="GBS.PT5.w.0.0.0"></a></div><div class="flow" style="">
<a class="page full_page_skipped" id="ORIG-GBS.PT1"></a>
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PT2"></a>
<div class="gimg_graphic" id="block.2.0.0.box.0.0.2509.1965.q.101" style="float:none;">
<a id="GBS.PT5.w.1.0.0"></a><img alt="[graphic]" src="data/content-0002.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PT5.w.1.0.0.1"></a></div>
<div class="gtxt_body" id="block.2.1.0.box.508.1955.1534.784.q.80">
<a id="ORIG-GBS.PT2.w.1.0.0"></a><p class="gtxt_body" id="para.2.1.0.box.508.1955.1534.784.q.80" style="font-size:135%;text-align:center;margin-left:0;color:rgb(0, 0, 0);">There Was an OLD LADY Who Swallowed Some BUGS</p>
</div>
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PT3"></a>
<div class="gimg_graphic" id="block.3.0.0.box.0.0.2553.3304.q.101" style="float:none;">
<a id="GBS.PT5.w.2.0.0"></a><img alt="[graphic]" src="data/content-0003.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PT5.w.2.0.0.1"></a></div>
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PT4"></a>
<div class="gtxt_body" id="block.4.0.0.box.251.166.2045.1044.q.80" style="margin-bottom: 1.5em;">
<a id="ORIG-GBS.PT4.w.0.0.0"></a><p class="gtxt_body" id="para.4.0.0.box.251.166.2045.1044.q.80" style="font-size:153%;text-align:center;margin-left:0;color:rgb(0, 0, 0);">There Was an OLD LADY Who Swallowed Some BUGS</p>
</div>
<div class="gtxt_body" id="block.4.1.0.box.870.1483.819.202.q.80">
<a id="ORIG-GBS.PT4.w.1.0.0"></a><p class="gtxt_body" id="para.4.1.0.box.870.1483.819.202.q.80" style="font-size:106%;text-align:right;text-align:center;margin-left:0;color:rgb(0, 0, 0);">Adapted and Illustrated by johnette Downing</p>
</div>
<div class="gimg_graphic" id="block.4.2.0.box.1198.2857.180.150.q.101" style="float:none;">
<a id="GBS.PT5.w.3.0.0"></a><img alt="[graphic]" src="data/content-0004.png" style="max-width:100%; max-height:100%"/><a id="GBS.PT5.w.3.0.0.1"></a></div>
<div class="gtxt_body" id="block.4.3.0.box.781.3025.997.130.q.80">
<a id="ORIG-GBS.PT4.w.3.0.0"></a><p class="gtxt_body" id="para.4.3.0.box.781.3025.997.58.q.90" style="text-align:right;text-align:center;color:rgb(0, 0, 0);clear:both;">PELICAN PUBLISHING COMPANY</p>
<a id="ORIG-GBS.PT4.w.3.1.0"></a><p class="gtxt_body" id="para.4.3.1.box.1110.3096.340.59.q.80" style="text-align:center;font-variant:small-caps;color:rgb(0, 0, 0);">Gretna 2010</p>
</div>
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PT5"></a>
<div class="gtxt_body" id="block.5.0.0.box.1104.141.224.51.q.80" style="margin-bottom: 1.5em;">
<a id="ORIG-GBS.PT5.w.0.0.0"></a><p class="gtxt_body" id="para.5.0.0.box.1104.141.224.51.q.80" style="text-align:right;text-align:center;font-style:italic;color:rgb(0, 0, 0);">For Dianne</p>
</div>
<div class="gtxt_body" id="block.5.1.0.box.155.254.431.155.q.70" style="margin-bottom: 1.5em;">
<a id="ORIG-GBS.PT5.w.1.0.0"></a><p class="gtxt_body" id="para.5.1.0.box.155.254.376.46.q.90" style="margin-left:0;margin-bottom:0;color:rgb(0, 0, 0);">Copyright © 2010</p>
<a id="ORIG-GBS.PT5.w.1.1.0"></a><p class="gtxt_body" id="para.5.1.1.box.155.308.431.46.q.80" style="margin-left:0;margin-bottom:0;color:rgb(0, 0, 0);">By Johnette Downing</p>
<a id="ORIG-GBS.PT5.w.1.2.0"></a><p class="gtxt_body" id="para.5.1.2.box.155.362.390.47.q.90" style="margin-left:0;margin-bottom:0;color:rgb(0, 0, 0);">All rights reserved</p>
</div>
<div class="gtxt_body" id="block.5.2.0.box.598.628.1236.160.q.60" style="margin-bottom: 1.5em;">
<a id="ORIG-GBS.PT5.w.2.0.0"></a><p class="gtxt_body" id="para.5.2.0.box.598.628.1236.160.q.60" style="text-indent:1em;text-align:center;font-style:italic;text-indent:0;color:rgb(0, 0, 0);">The word “Pelican” and the depiction of a pelican are trademarks of Pelican Publishing Company, Inc., and are registered in the U.S. Patent and Trademark Office.</p>
</div>
<div class="gtxt_body" id="block.5.3.0.box.155.1121.466.46.q.50" style="margin-bottom: 1.5em;">
<a id="ORIG-GBS.PT5.w.3.0.0"></a><p class="gtxt_body" id="para.5.3.0.box.155.1121.466.46.q.50" style="text-indent:1em;text-indent:0;color:rgb(0, 0, 0);">ISBN 9781589808584</p>
</div>
<div class="gtxt_body" id="block.5.4.0.box.95.2781.165.123.q.101">
<a id="ORIG-GBS.PT5.w.4.0.0"></a><p class="gtxt_body" id="para.5.4.0.box.95.2781.165.123.q.101" style="text-indent:1em;text-indent:0;color:rgb(0, 0, 0);">♾</p>
</div>
<div class="gimg_graphic" id="block.5.5.0.box.251.2750.177.161.q.101" style="float:none;">
<a id="GBS.PT5.w.4.0.0"></a><img alt="[graphic]" src="data/content-0005.png" style="max-width:100%; max-height:100%"/><a id="GBS.PT5.w.4.0.0.1"></a></div>
<div class="gtxt_body" id="block.5.6.0.box.155.2908.1022.157.q.70">
<a id="ORIG-GBS.PT5.w.6.0.0"></a><p class="gtxt_body" id="para.5.6.0.box.155.2908.423.46.q.80" style="margin-left:0;margin-bottom:0;color:rgb(0, 0, 0);">Printed in Singapore</p>
<a id="ORIG-GBS.PT5.w.6.1.0"></a><p class="gtxt_body" id="para.5.6.1.box.155.2962.952.49.q.70" style="margin-bottom:0;color:rgb(0, 0, 0);"><a id="GBS.PT5.w.4.1.0"></a>Published by Pelican Publishing Company, Inc.</p>
<a id="ORIG-GBS.PT5.w.6.2.0"></a><p class="gtxt_body" id="para.5.6.2.box.155.3016.1022.49.q.70">1000 Burmaster Street, Gretna, Louisiana 70053</p>
</div>
</div><div style="display:none;"><a id="GBS.PT6"></a><a id="GBS.PT6.w.0.0.0"></a><a id="GBS.PT6.w.1.0.0"></a></div>
<div style="display:none;"><a id="GBS.PT6.w.1.0.0.1"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content0006.vue?736f585d